import React, { useState } from 'react';
import { Box, Button, Layer, Text } from 'grommet';
import { Trash } from 'grommet-icons';
import PropTypes from 'prop-types';

// Trash icon that opens a "are you sure?" popup. `onConfirm` does the
// delete and must throw on failure; the popup then stays open and shows
// `errorMessage`. While the delete runs, the popup cannot be closed, so it
// never vanishes before the outcome is known.
export const ConfirmDeleteButton = ({
    a11yTitle,
    message,
    onConfirm,
    errorMessage = 'Could not delete. Please try again.',
}) => {
    const [showModal, setShowModal] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');

    const close = () => {
        if (busy) return;
        setError('');
        setShowModal(false);
    };

    const confirm = async () => {
        setBusy(true);
        setError('');
        try {
            await onConfirm();
            setShowModal(false);
        } catch (deleteError) {
            console.log(deleteError);
            setError(errorMessage);
        }
        setBusy(false);
    };

    return (
        <Box>
            <Button
                icon={<Trash color="enrich-red" />}
                a11yTitle={a11yTitle}
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <Layer onClickOutside={close} onEsc={close} position="center">
                    <Box
                        background="white"
                        pad="medium"
                        round="6px"
                        border={{ color: 'enrich-red', size: '3px' }}
                        gap="medium"
                        width="medium">
                        <Text>{message}</Text>
                        {error && <Text color="status-critical">{error}</Text>}
                        <Box direction="row" justify="end" gap="small">
                            <Button
                                label="Cancel"
                                disabled={busy}
                                onClick={close}
                            />
                            <Button
                                primary
                                color="enrich-red"
                                label="Delete"
                                busy={busy}
                                disabled={busy}
                                onClick={confirm}
                            />
                        </Box>
                    </Box>
                </Layer>
            )}
        </Box>
    );
};

ConfirmDeleteButton.propTypes = {
    a11yTitle: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};
